import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Box } from '@mui/material';
import DescribedField from '../DescribedField';

const SOCIAL_FIELDS = [
  { key: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/seuperfil' },
  { key: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/seuperfil' },
  { key: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/in/seuperfil' },
  { key: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@seucanal' },
  { key: 'twitter', label: 'Twitter / X', placeholder: 'https://twitter.com/seuperfil' },
  { key: 'tiktok', label: 'TikTok', placeholder: 'https://tiktok.com/@seuperfil' },
  { key: 'threads', label: 'Threads', placeholder: 'https://threads.net/@seuperfil' },
];

/**
 * SocialLinksBlockEditor — Editor do bloco Redes Sociais
 * TODO 4.14
 *
 * Props:
 *   - value: { instagram, facebook, linkedin, youtube, twitter, tiktok, threads }
 *   - onChange: (patch) => void
 *   - context: object
 */
const SocialLinksBlockEditor = ({ value = {}, onChange }) => {
  const patch = (field, val) => onChange({ ...value, [field]: val });

  return (
    <DescribedField
      label="Redes sociais"
      description="URLs das redes sociais que serão exibidas como ícones clicáveis na página. Deixe em branco as redes que não deseja exibir — ícones sem URL ficam ocultos. Use a URL completa, incluindo 'https://'."
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {SOCIAL_FIELDS.map(({ key, label, placeholder }) => (
          <TextField
            key={key}
            fullWidth
            label={label}
            value={value[key] || ''}
            onChange={(e) => patch(key, e.target.value)}
            placeholder={placeholder}
            size="small"
            type="url"
          />
        ))}
      </Box>
    </DescribedField>
  );
};

SocialLinksBlockEditor.propTypes = {
  value: PropTypes.shape({
    instagram: PropTypes.string,
    facebook: PropTypes.string,
    linkedin: PropTypes.string,
    youtube: PropTypes.string,
    twitter: PropTypes.string,
    tiktok: PropTypes.string,
    threads: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.object,
};

export default SocialLinksBlockEditor;
